import { render } from "./IndividualsView.vue?vue&type=template&id=600bb131&scoped=true"
import script from "./IndividualsView.vue?vue&type=script&lang=js"
export * from "./IndividualsView.vue?vue&type=script&lang=js"

import "./IndividualsView.vue?vue&type=style&index=0&id=600bb131&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600bb131"]])

export default __exports__